export const uiLoginContainer = {
    name: 'UI Login Container',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: []
        },
        defaultContent: {
            name: 'Default Content',
            type: 'Array',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [{ linkContentType: ['uiBlock', 'uiButton', 'uiColumn'] }],
                linkType: 'Entry'
            }
        },
        loggedInContent: {
            name: 'Logged In Content',
            type: 'Array',
            required: false,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [],
            items: {
                type: 'Link',
                validations: [{ linkContentType: ['uiBlock', 'uiButton', 'uiColumn'] }],
                linkType: 'Entry'
            }
        }
    }
};
//# sourceMappingURL=uiLoginContainer.js.map